// extracted by mini-css-extract-plugin
export default {"content_home":"Home_content_home__8sNUX"};